"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamSubscriptionSupplier = void 0;
var TeamSubscriptionSupplier;
(function (TeamSubscriptionSupplier) {
    TeamSubscriptionSupplier["UNKNOWN"] = "unknown";
    TeamSubscriptionSupplier["LEGACY"] = "legacy";
    TeamSubscriptionSupplier["STRIPE"] = "stripe";
})(TeamSubscriptionSupplier || (exports.TeamSubscriptionSupplier = TeamSubscriptionSupplier = {}));
